namespace RioERP.Inventory {
    export interface BookOutwardForm {
        BookId: Serenity.LookupEditor;
        OpeningBalance: Serenity.IntegerEditor;
        TotalInward: Serenity.IntegerEditor;
        TotalOutward: Serenity.IntegerEditor;
        BalanceQuantity: Serenity.IntegerEditor;
        OutwardMonth: Serenity.DateEditor;
        Notes: Serenity.StringEditor;
    }

    export class BookOutwardForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.BookOutward';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!BookOutwardForm.init)  {
                BookOutwardForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DateEditor;
                var w3 = s.StringEditor;

                Q.initFormType(BookOutwardForm, [
                    'BookId', w0,
                    'OpeningBalance', w1,
                    'TotalInward', w1,
                    'TotalOutward', w1,
                    'BalanceQuantity', w1,
                    'OutwardMonth', w2,
                    'Notes', w3
                ]);
            }
        }
    }
}
